import { render, staticRenderFns } from "./AmsHandwareProductsPage.vue?vue&type=template&id=5263be14"
import script from "./AmsHandwareProductsPage.vue?vue&type=script&lang=js"
export * from "./AmsHandwareProductsPage.vue?vue&type=script&lang=js"
import style0 from "./AmsHandwareProductsPage.vue?vue&type=style&index=0&id=5263be14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports